import { toLower } from "lodash";

const { isObjectNotEmpty, isStringNotEmpty, isNotNullOrUndefined, isBooleanTrue } = require("../utils/objectUtils");

class AffiliateInfo {
    offerId = null;
    affId = null;
    sub1 = null;
    sub2 = null;
    sub3 = null;
    sub4 = null;
    sub5 = null;
    uId = null;
    sourceId = null;
    transactionId = null;
    source = null;
    campaignId = null;
    programId = null;
    affiliateId = null;
    subAffiliateId = null;
    version = null;
    creativeId = null;
    clickId = null;
    couponCode = null;
    fbclid = null;
    fbc = null;
    siteVisitId = null;
    siteVisitAt = null;

    leadId = null;

    ttclid = null;
    gclid = null;
    irclickid = null;
    rdt_cid = null;
    SsCid = null;
    msclkid = null;
    twclid = null;
    nbclid = null;
    gbraid = null;

    utm_source = null;
    utm_campaign = null;
    utm_content = null;
    utm_medium = null;
    utm_term = null;

    productSku = null;
    offerGroupId = null;
    offerToken = null;
    addon = false;
    deviceFingerprint = null;
    ipAddress = null;

    constructor(affiliateInfo) {
        if (isObjectNotEmpty(affiliateInfo)) {
            if (isStringNotEmpty(affiliateInfo.offerId)) { this.offerId = affiliateInfo.offerId; }
            if (isStringNotEmpty(affiliateInfo.affId)) { this.affId = affiliateInfo.affId; }
            if (isStringNotEmpty(affiliateInfo.sub1)) { this.sub1 = affiliateInfo.sub1; }
            if (isStringNotEmpty(affiliateInfo.sub2)) { this.sub2 = affiliateInfo.sub2; }
            if (isStringNotEmpty(affiliateInfo.sub3)) { this.sub3 = affiliateInfo.sub3; }
            if (isStringNotEmpty(affiliateInfo.sub4)) { this.sub4 = affiliateInfo.sub4; }
            if (isStringNotEmpty(affiliateInfo.sub5)) { this.sub5 = affiliateInfo.sub5; }
            if (isStringNotEmpty(affiliateInfo.uId)) { this.uId = affiliateInfo.uId; }
            if (isStringNotEmpty(affiliateInfo.sourceId)) { this.sourceId = affiliateInfo.sourceId; }
            if (isStringNotEmpty(affiliateInfo.transactionId)) { this.transactionId = affiliateInfo.transactionId; }
            if (isStringNotEmpty(affiliateInfo.source)) { this.source = affiliateInfo.source; }
            if (isStringNotEmpty(affiliateInfo.campaignId)) { this.campaignId = affiliateInfo.campaignId; }
            if (isStringNotEmpty(affiliateInfo.programId)) { this.programId = affiliateInfo.programId; }
            if (isStringNotEmpty(affiliateInfo.affiliateId)) { this.affiliateId = toLower(affiliateInfo.affiliateId); }
            if (isStringNotEmpty(affiliateInfo.subAffiliateId)) { this.subAffiliateId = toLower(affiliateInfo.subAffiliateId); }
            if (isStringNotEmpty(affiliateInfo.version)) { this.version = toLower(affiliateInfo.version); }
            if (isStringNotEmpty(affiliateInfo.creativeId)) { this.creativeId = toLower(affiliateInfo.creativeId); }
            if (isStringNotEmpty(affiliateInfo.clickId)) { this.clickId = affiliateInfo.clickId; }
            if (isStringNotEmpty(affiliateInfo.couponCode)) { this.couponCode = affiliateInfo.couponCode; }
            if (isStringNotEmpty(affiliateInfo.fbclid)) { this.fbclid = affiliateInfo.fbclid; }
            if (isStringNotEmpty(affiliateInfo.fbc)) { this.fbc = affiliateInfo.fbc; }
            if (isStringNotEmpty(affiliateInfo.siteVisitId)) { this.siteVisitId = affiliateInfo.siteVisitId; }
            if (isNotNullOrUndefined(affiliateInfo.siteVisitAt)) { this.siteVisitAt = affiliateInfo.siteVisitAt; }

            if (isStringNotEmpty(affiliateInfo.leadId)) { this.leadId = affiliateInfo.leadId; }

            if (isStringNotEmpty(affiliateInfo.ttclid)) { this.ttclid = affiliateInfo.ttclid; }
            if (isStringNotEmpty(affiliateInfo.gclid)) { this.gclid = affiliateInfo.gclid; }
            if (isStringNotEmpty(affiliateInfo.irclickid)) { this.irclickid = affiliateInfo.irclickid; }
            if (isStringNotEmpty(affiliateInfo.rdt_cid)) { this.rdt_cid = affiliateInfo.rdt_cid; }
            if (isStringNotEmpty(affiliateInfo.SsCid)) { this.SsCid = affiliateInfo.SsCid; }
            if (isStringNotEmpty(affiliateInfo.msclkid)) { this.msclkid = affiliateInfo.msclkid; }
            if (isStringNotEmpty(affiliateInfo.twclid)) { this.twclid = affiliateInfo.twclid; }
            if (isStringNotEmpty(affiliateInfo.nbclid)) { this.nbclid = affiliateInfo.nbclid; }
            if (isStringNotEmpty(affiliateInfo.gbraid)) { this.gbraid = affiliateInfo.gbraid; }

            if (isStringNotEmpty(affiliateInfo.utm_source)) { this.utm_source = affiliateInfo.utm_source; }
            if (isStringNotEmpty(affiliateInfo.utm_campaign)) { this.utm_campaign = affiliateInfo.utm_campaign; }
            if (isStringNotEmpty(affiliateInfo.utm_content)) { this.utm_content = affiliateInfo.utm_content; }
            if (isStringNotEmpty(affiliateInfo.utm_medium)) { this.utm_medium = affiliateInfo.utm_medium; }
            if (isStringNotEmpty(affiliateInfo.utm_term)) { this.utm_term = affiliateInfo.utm_term; }

            if (isStringNotEmpty(affiliateInfo.productSku)) { this.productSku = affiliateInfo.productSku; }
            if (isStringNotEmpty(affiliateInfo.offerGroupId)) { this.offerGroupId = affiliateInfo.offerGroupId; }
            if (isStringNotEmpty(affiliateInfo.offerToken)) { this.offerToken = affiliateInfo.offerToken; }
            if (isBooleanTrue(affiliateInfo.addon)) { this.addon = true; }
            if (isStringNotEmpty(affiliateInfo.deviceFingerprint)) { this.deviceFingerprint = affiliateInfo.deviceFingerprint; }
            if (isStringNotEmpty(affiliateInfo.ipAddress)) { this.ipAddress = affiliateInfo.ipAddress; }
        }
    }

    toDto = () => {
        return {
            offerId: this.offerId,
            affId: this.affId,
            sub1: this.sub1,
            sub2: this.sub2,
            sub3: this.sub3,
            sub4: this.sub4,
            sub5: this.sub5,
            uId: this.uId,
            sourceId: this.sourceId,
            transactionId: this.transactionId,
            source: this.source,
            campaignId: this.campaignId,
            programId: this.programId,
            affiliateId: this.affiliateId,
            subAffiliateId: this.subAffiliateId,
            version: this.version,
            creativeId: this.creativeId,
            clickId: this.clickId,
            couponCode: this.couponCode,
            fbclid: this.fbclid,
            fbc: this.fbc,
            siteVisitId: this.siteVisitId,
            siteVisitAt: this.siteVisitAt,

            leadId: this.leadId,

            ttclid: this.ttclid,
            gclid: this.gclid,
            irclickid: this.irclickid,
            rdt_cid: this.rdt_cid,
            SsCid: this.SsCid,
            msclkid: this.msclkid,
            twclid: this.twclid,
            nbclid: this.nbclid,
            gbraid: this.gbraid,

            utm_source: this.utm_source,
            utm_campaign: this.utm_campaign,
            utm_content: this.utm_content,
            utm_medium: this.utm_medium,
            utm_term: this.utm_term,

            productSku: this.productSku,
            offerGroupId: this.offerGroupId,
            offerToken: this.offerToken,
            addon: this.addon,
            deviceFingerprint: this.deviceFingerprint,
            ipAddress: this.ipAddress
        };
    }

    toUpdateSiteVisitDto = () => {
        return {
            offerId: this.offerId,
            affId: this.affId,
            sub1: this.sub1,
            sub2: this.sub2,
            sub3: this.sub3,
            sub4: this.sub4,
            sub5: this.sub5,
            uId: this.uId,
            sourceId: this.sourceId,
            transactionId: this.transactionId,
            source: this.source,

            affiliateId: this.affiliateId,
            subAffiliateId: this.subAffiliateId,
            version: this.version,
            creativeId: this.creativeId,
            clickId: this.clickId,
            fbclid: this.fbclid,
            fbc: this.fbc,

            ttclid: this.ttclid,
            gclid: this.gclid,
            irclickid: this.irclickid,
            rdt_cid: this.rdt_cid,
            SsCid: this.SsCid,
            msclkid: this.msclkid,
            twclid: this.twclid,
            nbclid: this.nbclid,
            gbraid: this.gbraid,

            utm_source: this.utm_source,
            utm_campaign: this.utm_campaign,
            utm_content: this.utm_content,
            utm_medium: this.utm_medium,
            utm_term: this.utm_term,

            offerGroupId: this.offerGroupId,
            offerToken: this.offerToken
        };
    }
}

export default AffiliateInfo;
